const mEditionAssetContentsTreeNodes = {
  mEditionAssetContentsTreeNodes: {
    actions: 'acciones',
    subcontents: 'subcontenidos'
  }
}

export default mEditionAssetContentsTreeNodes
